const COLS = [
  { h: 'Product',   links: ['Use cases', 'How it works', 'Integrations', 'Pricing', 'Changelog'] },
  { h: 'Solutions', links: ['Abandoned cart', 'COD confirmation', 'Inbound support', 'Returns', 'Winback'] },
  { h: 'Company',   links: ['About', 'Customers', 'Careers', 'Contact', 'Privacy'] },
];

export function Footer() {
  return (
    <footer className="lp-footer">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="lp-footer-grid">
          <div>
            <img src="/logo.svg" alt="CallXcel" className="lp-footer-logo" />
            <p style={{ color: 'var(--text-3)', fontSize: 13.5, maxWidth: 280, lineHeight: 1.6 }}>
              AI voice agents for Shopify sales and support. Recover carts, confirm orders, and answer calls 24/7.
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.h}>
              <h5>{c.h}</h5>
              {c.links.map((l) => <a key={l}>{l}</a>)}
            </div>
          ))}
        </div>
        <div className="lp-footer-bottom">
          <span>© 2026 CallXcel. All rights reserved.</span>
          <div className="row"><a>Terms</a><a>Privacy</a><a>Security</a></div>
        </div>
      </div>
    </footer>
  );
}
